import React from 'react';
import ReactDOM from 'react-dom';
import App from './components/App/App';
import './translate';

ReactDOM.render(<App />, document.getElementById('root'));
